import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, LOCALE_ID } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { StoreSpecificConfigService } from '@scalefast/config-angular';

export const legalDocResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const pageId: string = route.paramMap.get('pageId') ?? '';
  const locale = inject(LOCALE_ID);
  const router = inject(Router);
  if (['cgv', 'privacy', 'rp'].includes(pageId)) {
    const pageData = loadHtmlData(locale.toLocaleLowerCase(), pageId);
    return pageData;
  } else {
    router.navigateByUrl('/not-found', { onSameUrlNavigation: 'reload', skipLocationChange: true });
    return false;
  }
};

const loadHtmlData = (lang: string, pageId: string) => {
  const storeSpecificService = inject(StoreSpecificConfigService);
  const http = inject(HttpClient);
  const httpOptions = {
    headers: new HttpHeaders({
      Accept: 'text/plain, */*, text/html',
      'Content-Type': 'application/json',
    }),
    responseType: 'text' as 'json',
  };

  const filePath = `assets/legals/${lang}/${pageId}.html` + '?buildId=' + storeSpecificService.get().buildId;
  return http.get(filePath, httpOptions);
};
